import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Input } from '@chakra-ui/react'
import { numberFormat } from '../../../../utils/formats/formats'

const InputCell = (props) => {
  const onFocus = () => {
    if (props.type === 'currency') {
      const event = { target: { value: numberFormat(props.value, 'number') } }
      props.onChange(event)
      props.onFocus(false)
    }
  }
  const onBlur = () => {
    if (props.type === 'currency') {
      const event = { target: { value: numberFormat(props.value, 'currency') } }
      props.onChange(event)
      props.onBlur(true)
    }
  }
  const value = useMemo(() => {
    return props.value
  }, [props.value])
  return (
    <Input
      textAlign="end"
      position={0}
      onBlur={onBlur}
      onFocus={onFocus}
      value={value}
      onChange={props.onChange}
    />
  )
}

InputCell.propTypes = {
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default InputCell
